module.exports = __webpack_public_path__ + "static/img/user2.842a26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user2.png
// module id = 1154
// module chunks = 2